module.exports = __webpack_public_path__ + "media/images/icons/outlined/gold-5abfefe79e03a0954bd58aa04a5d04f0.svg";